const EnrollmentView = {
  DeclaringPersonForm: 'DeclaringPersonForm',
  LegalPersonForm: 'LegalPersonForm',
  StepsForms: 'StepsForms',
};

export default EnrollmentView;
